export const setForms = (state, payload) => {
  state.forms = payload;
};

export const setSingleForm = (state, payload) => {
  state.single_form = payload;
};

export const setIncome = (state, payload) => {
  state.income = payload;
};

export const setExpenditures = (state, payload) => {
  state.expenditures = payload;
};

export const setDonations = (state, payload) => {
  state.donations = payload;
};

export const setAssets = (state, payload) => {
  state.assets = payload;
};

export const setLiabilities = (state, payload) => {
  state.liabilities = payload;
};

export const setBankDetails = (state, payload) => {
  state.banks = payload;
};
